import partnerDataCurrentMutation from '@/mixins/currentMutation/partnerDataCurrentMutation';
import { mapGetters } from 'vuex';
import lodash from 'lodash';

export default {
  mixins: [partnerDataCurrentMutation],
  computed: {
    ...mapGetters({
      loadingPartnerData: 'profile/dashboard/loadingPartnerData'
    }),
    isUcb() {
      return (
        this.partnerData?.url !== undefined &&
        ['ucbcz', 'ucbsk'].indexOf(this.partnerData.url) !== -1
      );
    },
    isMastercardorCsobMastercard() {
      const urls = ['csobmastercard', 'mastercard'];
      const current = this.partnerData?.url;
      return urls.includes(current);
    },
    showArticles() {
      if (this.loadingPartnerData || this.isUaRu) {
        return false;
      }
      if (!this.$auth?.user?.benefit?.active) {
        return true;
      }
      if (lodash.isEmpty(this.currentMutation)) {
        return true;
      }
      if (this.currentMutation.showArticles === undefined) {
        return true;
      }
      return this.currentMutation.showArticles;
    },
    showInsuranceProviderBenefitBox() {
      if (this.loadingPartnerData) {
        return false;
      }
      if (this.isHu) {
        return false;
      }
      if (!this.$auth?.user?.benefit?.active) {
        return true;
      }
      if (
        !lodash.isEmpty(this.currentMutation) &&
        this.currentMutation?.showInsuranceBenefits === undefined
      ) {
        return true;
      } else {
        return this.currentMutation?.showInsuranceBenefits;
      }
    },
    isThematicCounsellingEnabled() {
      return this.currentMutation?.showHealthTests || !this.$auth?.user?.benefit?.active;
    }
  }
};
